/* eslint-disable */

import React from 'react';
import classNames from 'classnames/bind';
import styles from './Terms.module.scss';

const cx = classNames.bind(styles);

function Terms_03() {
	return (
		<div className={cx('terms')}>
			<h3 className={cx('tit_terms', 'pt0')}>제1조 ( 목 적 )</h3>
			<p className={cx('cont_terms')}>
				이 약관은 엔카닷컴㈜가 운영하는 웹사이트(http://www.encar.com, 이하 "엔카"라 한다)에서 제공하는 중고자동차 중개 및 배송 서비스(이하
				“엔카 홈서비스”라 함)를 이용함에 있어 "엔카"와 "이용자"의 권리∙의무 및 책임사항을 규정함을 목적으로 합니다.
			</p>

			<h3 className={cx('tit_terms')}>제2조 ( 용어의 정의 )</h3>
			<ul className={cx('cont_terms')}>
				<li>
					① "엔카"란 엔카닷컴㈜가 중고자동차 및 관련 제반 상품서비스 또는 용역(이하 “중고자동차 등”이라 함)을 "이용자"에게 제공하기 위하여
					컴퓨터 등 정보통신 설비를 이용하여 중고자동차 등을 거래할 수 있도록 정한 가상의 영업장을 말하며, 아울러 온라인 몰을 운영하는
					사업자와 그 사업자가 지정한 장소의 의미로도 사용합니다.
				</li>
				<li>② "이용자"란 "엔카"의 이용약관에 동의하여 이 약관에 따라 “엔카 홈서비스”를 제공받는 자를 말합니다.</li>
				<li>③ “차량판매자”란 중고자동차의 실 소유자로 “엔카 홈서비스”를 통해 차량 판매를 신청한 자를 말합니다.</li>
			</ul>

			<h3 className={cx('tit_terms')}>제3조 ( 약관의 명시와 개정 )</h3>
			<ul className={cx('cont_terms')}>
				<li>
					① "엔카"는 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소(소비자의 불만을 처리할 수 있는 곳의 주소를 포함),
					전화번호∙모사전송번호∙전자우편주소, 사업자등록번호, 통신판매업 신고번호 등을 "이용자"가 쉽게 알 수 있도록 "엔카"의 초기
					서비스화면에 게시합니다. 다만 약관의 내용은 "이용자"가 연결화면을 통하여 볼 수 있도록 할 수 있습니다.
				</li>
				<li>
					② "엔카"는 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제에 관한 법률, 전자문서 및 전자거래 기본법, 전자금융거래법,
					전자서명법, 정보통신망 이용촉진등에 관한 법률, 방문판매등에 관한 법률, 소비자기본법, 개인정보보호법, 자동차관리법 등 관계법령을
					위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.
				</li>
				<li>
					③ "엔카"는 본 약관 개정 시, 적용일자 및 개정사유를 명시하여 현행 약관과 함께 "엔카" 초기화면에 적용일자 7일 이전부터 적용 일자
					전일까지 공지합니다. 다만, “이용자”에게 불리하게 약관내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 공지합니다.
					이 경우 "엔카"는 개정 전 내용과 개정 후 내용을 명확하게 비교하여 “이용자”가 알기 쉽도록 표시합니다.
				</li>
				<li>
					④ "엔카"가 이 약관을 개정하는 경우 그 개정약관은 적용일자 이후에 체결되는 계약에만 적용되고, 그 이전에 이미 체결된 계약에 대해서는
					개정전의 약관 조항이 그대로 적용됩니다. 다만 이미 계약을 체결한 "이용자"가 개정약관 조항의 적용을 받기를 원하는 뜻을 제3항에 의한
					개정약관의 공지기간 내에 "엔카"에 송신하여 "엔카"의 동의를 받은 경우에는 개정약관 조항이 적용됩니다.
				</li>
				<li>
					⑤ 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제 등에 관한
					법률, 공정거래위원회가 정하는 전자상거래 등에서의 소비자 보호지침 및 관계법령 또는 상관례에 따릅니다.
				</li>
			</ul>

			<h3 className={cx('tit_terms')}>제4조 (서비스의 제공 및 변경)</h3>
			<ul className={cx('cont_terms')}>
				<li>
					① "엔카"가 이 약관에 따라 "이용자"에게 제공하는 서비스는 다음과 같습니다.
					<ul>
						<li>1. 중고자동차 등에 대한 판매&middot;판매중개 및 정보 제공</li>
						<li>2. 구매계약이 체결된 중고자동차 등의 탁송</li>
						<li>3. 금융관련 정보 제공</li>
						<li>4. 휴대폰 문자메세지, 알림톡 등 정보 알림 서비스 제공</li>
						<li>5. 기타 "엔카"가 정하는 업무</li>
					</ul>
				</li>
				<li>
					② "엔카"는 필요한 경우 제공하는 서비스의 내용을 변경할 수 있으며, 이 경우 변경 내용 및 제공일자를 그 제공일자 7일 전부터
					공지합니다.
				</li>
				<li>
					③ "엔카"는 제2항에 따라 서비스의 내용을 변경한 경우, 그로 인하여 회원이 입은 손해에 대하여 배상하지 아니합니다. 단, "이용자"의
					손해가 "엔카"의 고의 또는 중대한 과실로 인한 경우에는 그러하지 아니합니다.
				</li>
			</ul>

			<h3 className={cx('tit_terms')}>제5조 ( 구매신청 )</h3>
			<ul className={cx('cont_terms')}>
				<li>
					① "엔카"가 이 약관에 따라 "이용자"에게 제공하는 서비스는 다음과 같습니다.
					<ul>
						<li>1. 중고자동차 및 “엔카 홈서비스” 및 결제방법 선택</li>
						<li>
							2. 차량을 배송받는 사람 또는 “차량판매자”와 협의된 장소에 방문하여 실물을 확인(이하 “방문픽업 서비스”)하는 사람의 성명,
							주소, 전화번호, 전자우편주소(또는 이동전화번호) 등의 입력
						</li>
						<li>3. 이용약관, 개인정보 수집이용, 배송료, 환불규정 등의 “엔카 홈서비스” 이용 및 비용부담과 관련한 내용에 대한 확인</li>
						<li>4. 위 3호의 사항들에 대한 확인 및 동의 또는 거부하는 표시(예, 마우스 클릭)</li>
						<li>5. 중고자동차 및 “엔카 홈서비스” 구매신청 및 이에 관한 확인 또는 "엔카"의 확인에 대한 동의</li>
					</ul>
				</li>
				<li>② 제1항에 따른 절차의 세부적인 사항은 “엔카 홈서비스” 화면에서 정한 바에 따릅니다.</li>
				<li>
					③ "이용자"는 구매신청 절차 완료 후 자동 발송되는 구매확인 알림톡과 "엔카" 마이페이지에서 실시간 구매현황을 확인할 수 있습니다.
				</li>
			</ul>

			<h3 className={cx('tit_terms')}>제6조 ( 구매신청의 확정 )</h3>
			<ul className={cx('cont_terms')}>
				<li>
					"엔카"는 "이용자"의 구매신청서 확인 후 “차량판매자”에게 해당 사실을 알리며, “엔카 홈서비스” 가능여부를 "이용자"에게 고지합니다.
					단, 다음 각호의 해당되는 경우 "엔카"는 "이용자"의 구매신청을 철회할 수 있습니다.
					<ul>
						<li>1. “차량판매자”가 차량 배송 전 또는 "이용자"의 “방문픽업 서비스” 이용 전 현장 방문 고객에게 차량 판매가 확정된 경우</li>
						<li>2. 자동차매매업의 질서를 해치거나 "이용자"에게 피해를 줄 우려가 있는 경우.</li>
					</ul>
				</li>
			</ul>

			<h3 className={cx('tit_terms')}>제7조 ( 구매계약의 성립 )</h3>
			<ul className={cx('cont_terms')}>
				<li>
					① "엔카"는 제5조에 따른 "이용자"의 구매신청이 다음 각호에 해당되는 경우 구매신청을 거부할 수 있습니다.
					<ul>
						<li>1. 신청 내용에 허위, 기재누락, 오기가 있는 경우</li>
						<li>2. 미성년자가 법정 대리인의 동의없이 “엔카 홈서비스”를 신청하는 경우</li>
						<li>3. "이용자"가 다른 사람의 사용자아이디∙비밀번호 및 신용카드번호를 도용하여 부당하게 구매신청을 하는 경우</li>
						<li>4. "이용자"가 해킹, 컴퓨터 바이러스 유포, 기타 이와 유사한 방법 등에 의하여 “엔카 홈서비스” 운영을 방해한 경우</li>
						<li>5. "이용자"가 중고자동차 구매계약체결 후 정당한 이유없이 환불을 진행한 횟수가 연간 2회 이상인 경우</li>
						<li>6. 기타 구매신청에 승낙하는 것이 기술상 또는 업무 수행상 현저히 지장이 있다고 판단하는 경우</li>
						<li>7. "이용자"가 "엔카" 이용약관 등 "엔카"가 정한 정책에 위배되는 행위를 한 이력이 있거나 할 것으로 의심되는 경우</li>
					</ul>
				</li>
				<li>
					② "엔카"는 본 조1항 각 호의 어느 하나에 해당하는 "이용자"의 회원자격을 영구 박탈하거나 본 서비스 이용을 일정기간 제한할 수
					있습니다.
				</li>
				<li>
					③ 구매계약은 "엔카"와 “차량판매자”의 승낙이 제8조 제1항의 수신확인통지 형태로 "이용자"에게 도달한 시점에 계약이 성립한 것으로
					봅니다.
				</li>
				<li>
					④ "엔카"는 구매계약이 체결된 이후 중고자동차의 가격·제원 등의 오기가 있음을 발견하였을 때, "이용자"에게 해당 오기를 정정하였을
					때의 가격으로 구매계약수정 요청을 할 수 있습니다. 다만, "이용자"가 정정가격으로 계약을 원하지 않을 경우 계약은 자동 취소됩니다.
					다만, "이용자"가 해당 차량 구매를 위해 대출∙보험계약을 체결하여 발생한 손해는 "엔카"가 보상합니다.
				</li>
			</ul>

			<h3 className={cx('tit_terms')}>제8조 ( 대금결제방법 )</h3>
			<ul className={cx('cont_terms')}>
				<li>
					① "엔카"에서 “엔카 홈서비스”를 이용하여 구매한 중고자동차 등에 대한 대금지급방법은 다음 각 호의 방법 중 가용한 방법으로 할 수
					있습니다.
					<ul>
						<li>1. 온라인 무통장 입금, 폰 뱅킹, 인터넷 뱅킹 등의 각종 계좌 이체</li>
						<li>2. 각종 카드 결제</li>
						<li>3. "엔카"와 제휴된 금융상품판매자를 통한 결제</li>
						<li>4. 마일리지 등 엔카가 제공한 포인트 또는 쿠폰에 의한 결제</li>
						<li>5. 기타 전자적 지급 방법에 의한 대금 지급 등</li>
					</ul>
				</li>
				<li>
					② "이용자"가 대출 등의 방법으로 대금결제를 해야 하는 경우에는 "엔카"가 별도로 정한 절차에 따라 진행합니다. 이 경우 금융기관에서
					대출 승인이 확정된 때 "이용자"의 구매계약이 성립된 것으로 합니다.
				</li>
			</ul>

			<h3 className={cx('tit_terms')}>제9조 ( 수신확인 통지, 구매신청 변경 및 취소 )</h3>
			<ul className={cx('cont_terms')}>
				<li>
					① "엔카"는 "이용자"의 구매신청이 있는 경우 “차량판매자”에게 해당 신청사실을 고지 및 판매의사를 확인한 후 "이용자"에게 수신 확인
					통지를 합니다.
				</li>
				<li>
					② 수신 확인 통지를 받은 "이용자"는 의사표시의 불일치 등이 있는 경우에는 수신확인 통지를 받은 후 즉시 구매신청 변경 및 취소를
					요청할 수 있고 "엔카"는 배송 전에 "이용자"의 요청이 있는 경우에는 지체 없이 그 요청에 따라 처리합니다. 다만 이미 대금을 지불한
					경우에는 "이용자"가 별도로 동의한 "엔카" 홈서비스 환불규정에 따릅니다.
				</li>
			</ul>

			<h3 className={cx('tit_terms')}>제10조 ( 중고자동차 등의 공급 )</h3>
			<ul className={cx('cont_terms')}>
				<li>
					① "엔카"는 "이용자"와 중고자동차 등의 공급시기에 관하여 별도의 약정이 없는 이상, "이용자"가 청약을 한 날부터 3영업일 이내에
					중고자동차 등의 공급에 필요한 조치를 취합니다. 다만, "엔카"가 이미 중고자동차 등의 대금의 전부 또는 일부를 받은 경우에는 대금을
					받은 날부터 3일 이내에 조치를 취합니다. 이때 "엔카"는 "이용자"가 중고자동차 등의 공급 절차 및 진행 사항을 확인할 수 있도록 적절한
					조치를 합니다.
				</li>
				<li>
					② "엔카"는 "이용자"가 구매한 중고자동차에 대해 배송수단, 수단별 배송비용 및 배송기간 등을 고지합니다. 만약 "엔카"가 고의 또는
					중대한 과실로 약정 배송기간을 초과한 경우에는 그로 인한 "이용자"의 손해를 배상하여야 합니다.
				</li>
				<li>
					③ "이용자"가 중고자동차를 구매한 시점부터 "엔카"가 "이용자"에게 중고자동차를 인도하기 전까지 사고가 발생하는 등의 사유로 인하여
					"이용자"가 구매계약을 체결한 시점의 자동차의 상태와 달라진 경우, "이용자"는 탁송된 중고자동차의 인수를 거부할 수 있으며, "엔카"는
					계약을 취소할 수 있습니다. 이 때 "엔카"는 "이용자"로부터 지급 받은 일체의 비용을 반환하여야 하며, "이용자"가 중고자동차 구매를
					위해 대출계약 또는 보험계약을 체결하여 이를 취소함으로써 손해가 발생하는 경우 해당 실제 손해애 대해서는 "엔카"가 배상합니다.
				</li>
			</ul>

			<h3 className={cx('tit_terms')}>제11조 ( 청약 철회 등 )</h3>
			<ul className={cx('cont_terms')}>
				<li>
					① "엔카 홈서비스" 를 통해 "엔카"와 중고자동차 등의 구매에 관한 계약을 체결한 "이용자"는 전자상거래 등에서의 소비자보호에 관한 법률
					제13조 제2항에 따른 계약 내용에 관한 서면(전자우편 포함)을 받은 날(그 서면을 받은 때보다 중고자동차 등의 공급이 늦게 이루어진
					경우에는 중고자동차 등을 공급받거나 공급이 시작된 날을 말합니다)부터 7일 이내 청약의 철회를 할 수 있습니다.
				</li>
				<li>
					② 제1항의 규정에도 불구하고, "이용자"는 다음 각 호의 1에 해당하는 경우에는 청약철회 등을 할 수 없습니다.
					<ul>
						<li>1. "이용자"에게 중고자동차가 배송된 후 "이용자"에게 책임 있는 사유로 중고자동차가 멸실되거나 훼손된 경우</li>
						<li>2. "이용자"에게 중고자동차가 배송된 후 "이용자"의 사용 또는 일부 소비에 의하여 재화 등의 가치가 현저히 감소한 경우</li>
						<li>3. 소유권이전등록절차를 진행하여 "이용자"의 명의로 소유권 이전 등록이 완료 된 때</li>
					</ul>
				</li>
				<li>
					③ 제2항 제1호 내지 제3호의 경우에는 "엔카"가 사전에 청약 철회 등이 제한되는 사실을 "이용자"가 쉽게 알 수 있는 곳에 명기하거나 신청
					상담시 안내 등의 조치를 하지 않았다면 "이용자"의 청약 철회 등이 제한되지 않습니다.
				</li>
				<li>
					④ "이용자"는 제 2항의 규정에도 불구하고 다음 각 호의 어느 하나에 해당하는 경우에는 자동차인도일부터 30일 이내에 해당 매매 계약을
					해제할 수 있다
					<ul>
						<li>1. 해당 자동차의 주행거리, 사고 또는 침수 사실이 자동차성능점검기록부의 고지 내용과 다른 경우</li>
						<li>2. 해당 자동차의 압류 및 저당권의 등록 여부가 최초 고지한 내용과 다른 경우</li>
					</ul>
				</li>
				<li>
					⑤ 청약철회 신청에 따른 환불절차, 환불기준, 환불이 불가한 비용 등은 본 약관과 별도로 "이용자"가 동의한 "엔카" 홈서비스 환불규정에서
					정하기로 합니다.
				</li>
			</ul>

			<h3 className={cx('tit_terms')}>제12조 ( 청약 철회 등의 효과 )</h3>
			<ul className={cx('cont_terms')}>
				<li>
					① "엔카"는 "이용자"로부터 제10조 제1항에 따른 청약의 철회가 있는 경우, 3영업일 이내에 이미 지급받은 중고자동차 등의 대금을
					반환합니다. 이 경우 "엔카"가 "이용자"에게 중고자동차 등의 반환을 지연한 때에는 그 지연 기간에 대하여 「전자상거래 등에서의
					소비자보호에 관한 법률 시행령」 제21조의2에서 정하는 지연 이자율을 곱하여 산정한 지연 이자(이하 "지연 배상금"이라 한다)를
					지급합니다.
				</li>
				<li>
					② "엔카"는 위 대금을 환급함에 있어서 "이용자"가 신용카드 등 대통령령이 정하는 결제 수단으로 중고자동차 등의 대금을 지급한 때에는
					지체 없이 당해 결제 수단을 제공한 사업자로 하여금 중고자동차 등의 대금 청구를 정지 또는 취소하도록 요청합니다.
				</li>
				<li>
					③ 청약철회의 경우 "엔카"는 이미 중고자동차 등이 일부 사용되거나 일부 소비된 경우에는 그 중고자동차 등의 일부 사용 또는 일부 소비에
					의하여 "이용자"가 얻은 이익 또는 그 중고자동차 등의 공급에 든 비용에 상당하는 금액을 "이용자"에게 청구할 수 있습니다.
				</li>
				<li>
					④ 청약철회 등의 경우 공급받은 중고자동차 등의 반환에 필요한 비용은 "이용자"가 부담합니다. "엔카"는 "이용자"에게 청약 철회 등을
					이유로 위약금 또는 손해배상을 청구하지 않습니다. 다만 중고자동차 등의 내용이 표시, 광고 내용과 다르거나 중대한 결함이 있음이
					사전에 발견 되어 청약 철회권을 행사하는 경우 위 대출취소 및 보험가입 취소에 따른 손해를 배상합니다.
				</li>
			</ul>

			<p className={cx('tit_terms')}>부칙</p>
			<p className={cx('cont_terms')}>가. 이 약관은 2022년 8월 30일 부터 시행합니다.</p>
		</div>
	);
}

export default Terms_03;
